import * as React from 'react';
export function withContext(Component, context) {
    const component = (props) => (React.createElement(context.Consumer, null, (value) => React.createElement(Component, Object.assign({}, props, value))));
    component.displayName = `with-context-${Component.displayName || Component.name}`;
    return component;
}
//# sourceMappingURL=with-context.js.map